define('controllers/passwordstrength',['require'],function(require) {
	return function() {		
		$(function () {
			function displayPasswordStrength(passwordValue) {
				var strength = "",
					color = "";

				switch (parseInt(passwordValue)) {
					case 1:
						strength = "Weak";
						color = "red";
						break;
					case 2:
						strength = "OK";
						color = "#F56607"; //yellow
						break;
					case 3:
						strength = "Fair";
						color = "#E0981B"; //orange
						break;
					case 4:
					    strength = "Good";
						color = "green";
						break;
				}

				$("div.bar", passwordStrength).each(function (index) {
					var $this = $(this),
						bgColor = (index + 1) <= passwordValue ? color : "#bbb";

					$this.css("background-color", bgColor);
				});
				$("#Strength", passwordStrength).css("color", color).text(strength);
				passwordStrength.show();
			}

			var passwordStrength = $("#passwordStrength");
			$("#" + window.ServerData.feData.NewPasswordBoxId).on("change", function () {
			    var password = $(this).val();
                var validForSite = new RegExp(window.ServerData.feData.passwordRegEx).test(password);

			    passwordStrength.hide();
			    if (password != "") {
			        if (validForSite) {
			            $.get("/public/passwordStrength.aspx?Passwd=" + password, function (passwordValue) {
			                displayPasswordStrength(passwordValue);
			            });
			        } else {
			            displayPasswordStrength(1);
			        }
			    }
			});

		});
	};
});
